// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";

const url = "/api/custom/category/getcategories";

export interface GetFeaturedCategoriesApiParameter extends ApiParameter {
    categories: string[];
}

export async function getFeaturedCategories(
    parameter: GetFeaturedCategoriesApiParameter,
): Promise<ServiceResult<CategoryModel[]>> {
    try {
        const result = await get<CategoryModel[]>(url, parameter);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

